import React, { useState } from "react";
import "./Layout.css";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { Footer } from "./Footer";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { DashboardPage } from "../dashboard/DashboardPage";
import { PracticePage } from "../practice/PracticePage";
import { CoachingPage } from "../coaching/CoachingPage";
import { FeedPage } from "../feed/FeedPage";
import { TeamDashboard } from "../team/TeamDashboard";
import { SettingsPage } from "../admin/SettingsPage";
import { canAccess } from "../../config/access";

export function Layout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    const saved = localStorage.getItem("protrain-sidebar-collapsed");
    return saved === null ? false : saved === "true";
  });
  const { role } = useAuth();

  const handleToggle = () => {
    const next = !sidebarCollapsed;
    setSidebarCollapsed(next);
    localStorage.setItem("protrain-sidebar-collapsed", String(next));
  };

  return (
    <div className="protrain-layout">
      <Header />
      <div className="protrain-layout-body">
        <Sidebar collapsed={sidebarCollapsed} onToggle={handleToggle} />
        <main className="protrain-content">
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/practice" element={<PracticePage />} />
            <Route path="/coaching" element={<CoachingPage />} />
            <Route path="/learn" element={<FeedPage />} />
            {canAccess(role, ["sales_manager", "admin"]) && (
              <Route path="/team" element={<TeamDashboard />} />
            )}
            {canAccess(role, ["admin"]) && (
              <Route path="/settings" element={<SettingsPage />} />
            )}
          </Routes>
        </main>
      </div>
      <Footer />
    </div>
  );
}
